import { Dispatch, SetStateAction } from 'react';

export const toggleCollapsibleBlockMapInfo = ({
	name,
	collapsibleBlocks,
	setCollapsibleBlocks,
	initialState,
	disableOneItemOpenedAtATime = false,
}: {
	name: string;
	collapsibleBlocks: Record<string, boolean>;
	setCollapsibleBlocks: Dispatch<SetStateAction<Record<string, boolean>>>;
	initialState: Record<string, boolean>;
	disableOneItemOpenedAtATime?: boolean;
}) => {
	if (disableOneItemOpenedAtATime) {
		setCollapsibleBlocks(prevState => ({
			...prevState,
			[name]: !collapsibleBlocks[name],
		}));
	} else {
		const isAlreadyOpen = collapsibleBlocks[name];

		if (isAlreadyOpen) setCollapsibleBlocks(initialState);
		else {
			setCollapsibleBlocks(prevState => {
				const newState: Record<string, boolean> = {};

				for (const key in prevState) {
					newState[key] = key === name;
				}

				return newState;
			});
		}
	}
};
